@if (!meeting.hasWarningForMissingAgendaBeenShown && !meeting.hasMinutes) {
  <div class="blurred-background">
    <div class="panel">
      <div class="description" translate="MEETINGS.AGENDA_MISSING_WARNING"></div>
      <div class="buttons">
        <button mat-raised-button color="primary" (click)="openAgendaUpload.emit()" translate="MEETINGS.AGENDA_MISSING_WARNING_UPLOAD_BUTTON"></button>
        <div translate="COMMON.OR"></div>
        <button mat-raised-button (click)="approveMissingAgenda()" translate="MEETINGS.AGENDA_MISSING_WARNING_SKIP_BUTTON"></button>
      </div>
    </div>
  </div>
}
